import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
export function Card({
  children,
  className = ''
}: CardProps) {
  return <div className={`bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 ${className}`} data-id="element-293">
      {children}
    </div>;
}